/**
 */
import I96ScrollChecker from "../i96-scroll_checker.class.js";

class I96Parallax extends I96ScrollChecker {

    constructor(config = {}) {

        super(config);

        this.settings_parallax = {
            selector_container: '.i96-parallax-container',
            selector_element: '.i96-parallax-element',
            start_at_x: 300
        }

        this.debug = config.debug ?? false;

        if (this.debug) console.log('I96ParallaxScrolling: constructor('+config+')');

        this.scroll_data.parallax = {
            visible_height: 0,
            threshold: 0,
            visible: false,
            // pixel is quicker for smaller heights
            use_pixel: true
        };

        this.init_data = {
            wait_max: 100,
            wait_delay: 50,
            interval: null,
            wait_count: 0
        }

        this.init();

    }

    init() {
        if (this.debug) console.log('I96ParallaxScrolling: init()');

        this._setupEvents()

    }

    _getContainer() {
        return document.querySelectorAll(this.settings_parallax.selector_container)
    }

    /**
     * Returns the first header element found, otherwise false
     * @returns {Element|boolean}
     */
    getFirstContainer() {
        const el = this._getContainer()
        if (el.length) {
            return el[0]
        }
        return false
    }

    _setupEvents() {

        if (this.debug) console.log('I96ParallaxScrolling: _setupEvents()');

        if (!this.getFirstContainer()) {
            if (this.debug) console.log('I96ParallaxScrolling: _setupEvents() > none found', this.settings_parallax.selector_container);
            return
        }

        this.$FirstImage = this.getFirstContainer();

        if (this.$FirstImage !== false) {
            this._setupScroll( this._onScroll.bind(this) );
        }
    }


    /**
     * Helper function to reset the animation state of the header to the initial values opacity: 1 and translateY: 0
     * @private
     */
    _resetFade() {
        this._setFade(1, '0');
    }

    /**
     * Helper function to set the animation state of the header
     * @param opacity
     * @param translatey
     * @private
     */
    _setFade(opacity, translatey) {
        this.$FirstImage.style.opacity = opacity;
        this.$FirstImage.style.transform = 'translateY('+translatey+')'
    }

    /**
     * Applies the 'fade state' depending on the current header position
     * @private
     */
    _directFade() {
        if (this.debug) console.log('I96ParallaxScrolling: _directFade()', window.scrollY, this.scroll_data);

        if (this.$FirstImage == null) {
            return;
        }



        const max_visible_height = this.scroll_data.variant_1.use_pixel ? this.$stickyheader.getBoundingClientRect().height : 100


        // Don't fade the header when it is not stuck to the top of the screen (better to check it indirectly, no need to see the current fade state...)
        const trigger_rect = this.getTriggerRect()
        if ((trigger_rect.height + trigger_rect.top) > 0) {
            return;
        }

        // opacity
        this.scroll_data.variant_1.visible_height += this.scroll_data.pos.diff

        // TODO: don't do the calcs EVERY TIME

        // negative kinetic scroll fix
        if (window.scrollY >= 0) {
            this.$stickyheader.classList.remove('-negative-y');
        } else {
            this.$stickyheader.classList.add('-negative-y');
        }

        // hide if nothing is visible
        if (this.scroll_data.variant_1.visible_height < 0 && this.scroll_data.pos.curr > 0
            // fixing safari kinetic scroll problem where the header is hidden when we scroll up into negative space
            && window.scrollY > 0) {
            if (this.debug) console.log('I96StickyHeader: _directFade(): hide if nothing is visible');
            this.scroll_data.variant_1.visible = false
            this.scroll_data.variant_1.visible_height = 0

            this._setHeaderFade(0, '-100%');
            // this.$stickyheader.style.opacity = 0
            // this.$stickyheader.style.transform = 'translateY(-100%)'
        } else

            // show if fully visible
        if ( (this.scroll_data.variant_1.visible_height > max_visible_height) || this.scroll_data.pos.curr === 0) {
            if (this.debug) console.log('I96StickyHeader: _directFade(): show if fully visible', this.scroll_data.variant_1.visible_height, max_visible_height, this.scroll_data.pos.curr);
            this.scroll_data.variant_1.visible_height = max_visible_height
            this.scroll_data.variant_1.visible = true

            this._resetHeaderFade();
            // this.$stickyheader.style.opacity = 1
            // this.$stickyheader.style.transform = 'translateY(0)'

            // transition phase with < 1 opacity and position
        } else {
            // don't do it for safari negative y kinetic scroll
            if (window.scrollY > 0) {
                if (this.debug) console.log('I96StickyHeader: _directFade(): transition phase with < 1 opacity and position');

                this._setHeaderFade(
                    (this.scroll_data.variant_1.visible_height / max_visible_height),
                    '-' + (max_visible_height - this.scroll_data.variant_1.visible_height) +
                    (this.scroll_data.variant_1.use_pixel ? 'px' : '%')
                )
                // this.$stickyheader.style.opacity = (this.scroll_data.variant_1.visible_height / max_visible_height)
                // this.$stickyheader.style.transform = 'translateY(-' + (max_visible_height - this.scroll_data.variant_1.visible_height) +
                //   (this.scroll_data.variant_1.use_pixel ? 'px' : '%') + ')';
            } else {
                console.log('window.scrollY smaller zero: ', window.scrollY);
            }
        }

    }


    _onScroll() {

        // if (this.debug) console.log('I96StickyHeader: _onScroll()', this.scroll_data);

        const val = parseInt( this.scroll_data.pos.curr ) * 0.2;
        this.$FirstImage.style.transform = 'translateY('+val+'px)';

        let opacity = 1;

        if (this.scroll_data.pos.curr > this.settings_parallax.start_at_x) {
            opacity = Math.max(0.25, 1 - (( this.scroll_data.pos.curr - this.settings_parallax.start_at_x) * 0.0025));
        }
        // todo: only on change
        this.$FirstImage.style.opacity = opacity;


    }


}

export default I96Parallax
